import React, { useState, useEffect } from "react";
import { Button, Grid, FormControl, FormControlLabel, Checkbox, LinearProgress, Box } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { patchClubs } from "api/admin/clubs";
import { Club } from "api/clubs";
import i18n from "./i18n";

// prop types
interface MembersTabProps {
    club?: Club,
    onFetchUserProfile: () => void,
}

// member club settings tab
const MembersTab = ({ club, onFetchUserProfile }: MembersTabProps) => {
    // snackbar
    const { enqueueSnackbar } = useSnackbar();
    const displayError = (error: any) => enqueueSnackbar(
        `${i18n.anErrorOccurred}: ${error.description} (${error.type})`,
        { variant: "error" },
    );

    // ui state
    const [autoAcceptMembershipRequests, setAutoAcceptMembershipRequests] = useState(false);
    const [autoInviteMembersToEvents, setAutoInviteMembersToEvents] = useState(false);
    const [isLoading, setLoading] = useState(false);

    // save action
    const saveAction = async () => {
        setLoading(true);
        try {
            await patchClubs({
                autoAcceptMembershipRequests,
                autoInviteMembersToEvents,
                clubIds: [club!.id],
            });
            onFetchUserProfile(); // refresh clubs
            enqueueSnackbar(i18n.savedSuccessfully, { variant: "success" });
        } catch (error) {
            displayError(error);
        }
        setLoading(false);
    };

    // update fields
    useEffect(() => {
        if (club) {
            setAutoAcceptMembershipRequests(club.autoAcceptMembershipRequests);
            setAutoInviteMembersToEvents(club.autoInviteMembersToEvents);
        }
    }, [club]);

    // render
    return (
        <Box style={{ alignItems: "center", display: "flex", flexDirection: "column", padding: "16px" }}>
            <Grid container spacing={2}>

                {/* auto accept membership req */}
                <Grid item xs={12}>
                    <FormControl>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={autoAcceptMembershipRequests}
                                    color="primary"
                                    onChange={(e) => setAutoAcceptMembershipRequests(e.target.checked)}
                                />
                            )}
                            label={i18n.autoAcceptMembershipRequests}
                        />
                    </FormControl>
                </Grid>

                {/* auto invite new members */}
                <Grid item xs={12}>
                    <FormControl>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={autoInviteMembersToEvents}
                                    color="primary"
                                    onChange={(e) => setAutoInviteMembersToEvents(e.target.checked)}
                                />
                            )}
                            label={i18n.autoInviteMembersToEvents}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    {isLoading && <LinearProgress />}
                </Grid>
            </Grid>

            {/* save button */}
            <Button
                color="primary"
                disabled={isLoading}
                style={{ margin: "16px" }}
                variant="contained"
                onClick={saveAction}
            >
                {i18n.save}
            </Button>
        </Box>
    );
};

export default MembersTab;
